
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-rewriter?id=data-v-1cb162f8!../node_modules/vue-loader/lib/selector?type=styles&index=0!./ContentWrap.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./ContentWrap.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-1cb162f8!../node_modules/vue-loader/lib/selector?type=template&index=0!./ContentWrap.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/ContentWrap.vue
// module id = 656
// module chunks = 0